/* Uit Krabbelpaal.dc.html; bodies letterlijk overgenomen. */

import { api, asJson } from '../lib/api.js';
import { GH, GRID, GW, PB_URL, setGridSize } from '../lib/config.js';
import { PALETTE_HEX, paletteIndexOf } from '../lib/palette.js';
import { playBlip, playPop } from '../lib/sound.js';

export default {
  // Samen krabbelen speelt zich helemaal in het tekenscherm af, en dat bestaat op
  // een telefoon niet. Zowel iemand uitnodigen als een uitnodiging aannemen weigert
  // daar dus, met een uitleg in plaats van een scherm dat meteen weer wegklapt.
  openDuoPick() {
      if (this.state.isMobile) { this.notify('Samen krabbelen gaat op een computer.'); return; }
      return this.setState({ dialog: 'duoPick', duoError: '' });
    },

  duoEncode() {
      const ctx = this.getCtx();
      if (!ctx) return '';
      const d = ctx.getImageData(0, 0, GW, GH).data;
      let out = '';
      for (let i = 0; i < GW * GH; i++) {
        if (!d[i * 4 + 3]) { out += '.'; continue; }
        const hex = '#' + [0, 1, 2].map((k) => d[i * 4 + k].toString(16).padStart(2, '0')).join('');
        const idx = paletteIndexOf(hex);
        out += idx < 0 ? '0' : idx.toString(16);
      }
      return out;
    },

  duoApply(str) {
      const ctx = this.getCtx();
      if (!ctx || !str || str.length !== GW * GH) return;
      ctx.clearRect(0, 0, GW, GH);
      for (let i = 0; i < str.length; i++) {
        const ch = str[i];
        if (ch === '.') continue;
        const idx = parseInt(ch, 16);
        if (isNaN(idx) || !PALETTE_HEX[idx]) continue;
        ctx.fillStyle = PALETTE_HEX[idx];
        ctx.fillRect(i % GW, Math.floor(i / GW), 1, 1);
      }
    },

  // Iedereen mag overal tekenen. De laatst verzonden staat is de basis voor een
  // driewegsamenvoeging: wat de ander veranderde wint, de rest blijft van mij.
  duoMerge(remote) {
      if (!remote || remote.length !== GW * GH) return;
      // Wacht met samenvoegen zolang onze eigen pixels nog onderweg zijn: het
      // antwoord van de server is dan nog oud en zou net getekende cellen wissen.
      if (this.duoSending) { this.duoPendingRemote = remote; return; }
      const local = this.duoEncode();
      const base = this.duoBase && this.duoBase.length === remote.length ? this.duoBase : local;
      let out = '';
      for (let i = 0; i < remote.length; i++) out += remote[i] !== base[i] ? remote[i] : local[i];
      this.duoBase = out;
      if (out !== local) this.duoPatchCells(local, out);
      if (out !== remote) this.duoQueueSend();
    },

  // Zet alleen de cellen die verschillen; geen clearRect over de hele plaat,
  // zodat pixels die je net tekende niet even wegflitsen of verdwijnen.
  duoPatchCells(from, to) {
      const ctx = this.getCtx();
      if (!ctx) return;
      for (let i = 0; i < to.length; i++) {
        if (from[i] === to[i]) continue;
        const x = i % GW, y = Math.floor(i / GW);
        ctx.clearRect(x, y, 1, 1);
        const idx = parseInt(to[i], 16);
        if (to[i] !== '.' && !isNaN(idx) && PALETTE_HEX[idx]) { ctx.fillStyle = PALETTE_HEX[idx]; ctx.fillRect(x, y, 1, 1); }
        if (this.opBefore) this.opBefore[i] = to[i];
      }
      if (this.canvasRef.current) this.savedImage = ctx.getImageData(0, 0, GW, GH);
    },

  duoQueueSend() {
      if (!this.state.duo) return;
      clearTimeout(this.duoSendTimer);
      this.duoSendTimer = setTimeout(this.duoSend, 150);
    },

  async duoSend() {
      const duo = this.state.duo;
      if (!duo) return;
      if (this.duoSending) { this.duoResend = true; return; }
      const pixels = this.duoEncode();
      if (pixels === this.duoLastSent) return;
      this.duoSending = true;
      let ok = false;
      try {
        const res = await api(`${PB_URL}/api/collections/paal_duo/records/${duo.id}`, asJson('PATCH', { pixels }));
        ok = res.ok;
        if (ok) { this.duoLastSent = pixels; this.duoBase = pixels; }
      } catch (e) {}
      this.duoSending = false;
      const pending = this.duoPendingRemote;
      this.duoPendingRemote = null;
      if (pending) this.duoMerge(pending);
      if (!ok) { clearTimeout(this.duoSendTimer); this.duoSendTimer = setTimeout(this.duoSend, 1200); return; }
      if (this.duoResend || this.duoEncode() !== this.duoLastSent) { this.duoResend = false; this.duoQueueSend(); }
    },

  setDuoGrid(on, then) {
      setGridSize(on ? 64 : GRID, GRID);
      this.undoStack = []; this.redoStack = []; this.opBefore = null;
      this.savedImage = null;
      this.setState({ undoN: 0, redoN: 0, sel: null, lassoPts: null }, () => {
        this.computeCanvasSize();
        requestAnimationFrame(() => {
          const ctx = this.getCtx();
          if (ctx) { ctx.imageSmoothingEnabled = false; ctx.clearRect(0, 0, GW, GH); }
          if (then) then();
        });
      });
    },

  async startDuo(acc) {
      if (this.state.isMobile) { this.notify('Samen krabbelen gaat op een computer.'); return; }
      if (!this.state.accountId) { this.setState({ duoError: 'Kies eerst je eigen account.' }); return; }
      this.setState({ duoBusy: true, duoError: '' });
      try {
        const res = await api(`${PB_URL}/api/collections/paal_duo/records`, asJson('POST', { aId: this.state.accountId, bId: acc.id, status: 'invited', pixels: '.'.repeat(64 * GRID) }));
        if (!res.ok) throw new Error(res.status === 404 ? 'missing' : String(res.status));
        const rec = await res.json();
        this.duoLastSent = null;
        this.duoBase = null;
        this.duoSending = false;
        this.duoPendingRemote = null;
        this.snapshotCanvas();
        this.setState({ duoBusy: false, dialog: null, duo: { id: rec.id, aId: rec.aId, bId: rec.bId, status: 'invited' }, duoPartnerName: acc.name, studioOpen: true, studioMin: false }, () => {
          this.setDuoGrid(true);
          this.startDuoPoll();
        });
      } catch (e) {
        this.setState({
          duoBusy: false,
          duoError: e.message === 'missing'
            ? 'Maak op de server de collectie paal_duo aan met velden aId, bId, status, pixels (tekst).'
            : 'Uitnodigen mislukt. Probeer het nog eens.'
        });
      }
    },

  async acceptDuo() {
      if (this.state.isMobile) { this.notify('Deze uitnodiging neem je op een computer aan; daar kun je samen tekenen.'); return; }
      const inv = this.state.duoInvite;
      if (!inv) return;
      try {
        await api(`${PB_URL}/api/collections/paal_duo/records/${inv.id}`, asJson('PATCH', { status: 'active' }));
      } catch (e) {}
      const partner = (this.state.accounts || []).find((a) => a.id === inv.aId);
      this.duoLastSent = null;
      this.duoBase = null;
      this.duoSending = false;
      this.duoPendingRemote = null;
      this.snapshotCanvas();
      this.setState({
        duoInvite: null, duo: { id: inv.id, aId: inv.aId, bId: inv.bId, status: 'active' },
        duoPartnerName: partner ? partner.name : 'je partner', studioOpen: true, studioMin: false, dialog: null
      }, () => {
        this.setDuoGrid(true, () => { this.duoApply(inv.pixels); this.duoLastSent = inv.pixels; this.duoBase = inv.pixels; });
        this.startDuoPoll();
        playPop();
      });
    },

  async declineDuo() {
      const inv = this.state.duoInvite;
      this.setState({ duoInvite: null });
      if (!inv) return;
      try {
        await api(`${PB_URL}/api/collections/paal_duo/records/${inv.id}`, asJson('PATCH', { status: 'done' }));
      } catch (e) {}
    },

  async endDuo(keepStatus) {
      const duo = this.state.duo;
      this.stopDuoPoll();
      clearTimeout(this.duoSendTimer);
      this.duoLastSent = null;
      this.duoBase = null;
      this.duoSending = false;
      this.duoPendingRemote = null;
      this.setState({ duo: null, duoPartnerName: '' }, () => {
        this.setDuoGrid(false, () => { this.needsRestore = false; this.restoreWip(); });
      });
      if (!duo || keepStatus) return;
      try {
        await api(`${PB_URL}/api/collections/paal_duo/records/${duo.id}`, asJson('PATCH', { status: 'done', endedBy: this.state.accountId || '' }));
      } catch (e) {}
    },

  startDuoPoll() {
      this.stopDuoPoll();
      this.duoTimer = setInterval(() => { if (!document.hidden) this.fetchDuo(); }, 3000);
    },

  stopDuoPoll() { if (this.duoTimer) { clearInterval(this.duoTimer); this.duoTimer = null; } },

  async fetchDuo() {
      const me = this.state.accountId;
      if (!me) return;
      try {
        const filter = encodeURIComponent(`(aId="${me}" || bId="${me}") && status!="done"`);
        const res = await api(`${PB_URL}/api/collections/paal_duo/records?filter=${filter}&sort=-created&perPage=1`);
        if (!res.ok) return;
        const data = await res.json();
        const rec = (data.items || [])[0];
        const duo = this.state.duo;
        if (!rec) {
          if (duo) {
            // De sessie is voorbij: kijk wie er gestopt is, zodat de ander het hoort.
            let endedBy = '';
            try {
              const one = await api(`${PB_URL}/api/collections/paal_duo/records/${duo.id}`);
              if (one.ok) endedBy = (await one.json()).endedBy || '';
            } catch (e2) {}
            if (endedBy && endedBy !== this.state.accountId) {
              const who = (this.state.accounts || []).find((a) => a.id === endedBy);
              this.notify((who ? who.name : 'Je partner') + ' is gestopt met samen krabbelen.');
              playBlip();
            }
            this.endDuo(true);
          } else if (this.state.duoInvite) this.setState({ duoInvite: null });
          return;
        }
        if (duo && rec.id === duo.id) {
          const partnerId = duo.aId === me ? duo.bId : duo.aId;
          const partner = (this.state.accounts || []).find((a) => a.id === partnerId);
          const seenAt = partner ? Date.parse(partner.lastSeen || '') : NaN;
          if (rec.status === 'active' && partner && !isNaN(seenAt) && Date.now() - seenAt > 180000) {
            this.notify((partner.name || 'Je partner') + ' lijkt weg te zijn. Samen krabbelen is gestopt.');
            playBlip();
            this.endDuo();
            return;
          }
          if (rec.status === 'active' && duo.status !== 'active') {
            this.setState({ duo: { ...duo, status: 'active' } });
            playPop();
          }
          this.duoMerge(rec.pixels || '');
          return;
        }
        if (!duo && rec.status === 'invited' && rec.bId === me) {
          const inviter = (this.state.accounts || []).find((a) => a.id === rec.aId);
          const invSeen = inviter ? Date.parse(inviter.lastSeen || '') : NaN;
          if (inviter && !isNaN(invSeen) && Date.now() - invSeen > 180000) {
            if (this.state.duoInvite) this.setState({ duoInvite: null });
            return;
          }
          if (!this.state.duoInvite || this.state.duoInvite.id !== rec.id) {
            this.setState({ duoInvite: { id: rec.id, aId: rec.aId, bId: rec.bId, pixels: rec.pixels || '' } });
            playBlip();
          }
        }
      } catch (e) {}
    }
};
